export const a = null

export const musicList = [
  [{
      text: '开天辟地的利斧之声',
      desc: '毛泽东：我毛泽东宁可在这立枷中站着死,也不愿意忍气吞声躺着活。',
      isNotPause: true,
      // musicSrc: require('@/assets/music/music1.mp3'),
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623914824818/1、开天辟地的利斧之声.mp3',

      isMusicpause: false,

    },
    {
      text: '枪杆子里出政权',
      desc: '毛泽东：四一二大屠杀告诉了我们一个真理，枪杆子里出政权。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623914911498/2、枪杆子里出政权.mp3',
      isMusicpause: false,

    },
    {
      text: '星火燎原的铿锵誓言',
      desc: '毛泽东：星星之火，可以燎原。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623914930647/3、星火燎原的铿锵誓言.mp3',
      isMusicpause: false,

    },
    {
      text: '漫漫长征锤炼炽热信仰',
      desc: '毛泽东：山，快马加鞭未下鞍。惊回首，离天三尺三。山，倒海翻江卷巨澜。奔腾急，万马战犹酣。山，刺破青天锷未残。天欲堕，赖以拄其间。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1624689470106/长征.mp3',
      isMusicpause: false,

    },
    {
      text: '共敌强掳的急切呼告',
      desc: '毛泽东：一句话，走团结和民主的路线，打败侵略者，建设新中国。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623914970649/5、共敌强掳的急切呼告.mp3',
      isMusicpause: false,

    },
    {
      text: '毛泽东弥天大勇赴渝州',
      desc: '毛泽东：重庆我是要去的，不去，不足以表明我们和平的诚意；不去，不能粉碎敌人的阴谋；不去，不能让我们的国际朋友明白，我们的愿望就是和平。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623914987068/6、毛泽东弥天大勇赴渝州.mp3',
      isMusicpause: false,

    },
    {
      text: '解放中国，解放全人民',
      desc: '毛泽东：解放军将士们，中央军委命令你们，打过长江去，解放全中国！',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915004710/7、解放中国，解放全人民！.mp3',
      isMusicpause: false,

    },
    {
      text: '中国民主政治揭开崭新一页',
      desc: '毛泽东：诸位代表先生们，我们有一个共同的感觉，这就是我们的工作将写在人类的历史上，它将表明占人类总数四分之一的中国人从此站立起来了！',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915024758/8、中国民主政治揭开崭新一页.mp3',
      isMusicpause: false,

    },
  ],



  [{
      text: '毛泽东：新中国成立了',
      desc: '毛泽东：同胞们，中华人民共和国，中央人民政府，今天成立了！',
      isNotPause: true,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915088719/1、毛泽东：新中国成立了！.mp3',
      isMusicpause: false,

    },
    {
      text: '新中国的立威之战',
      desc: '毛泽东：唇亡则齿寒，户破而堂危，我们不能看着朝鲜亡国不管，只要他们越过三八线，我们必须打过去。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915175053/6、新中国的立国之战.mp3',
      isMusicpause: false,

    },
    {
      text: '风雨外交路开辟中国新征程',
      desc: '周恩来：越来越多的国家认识到，为维护政治独立、发展民族经济与文化，加强国际合作是唯一的出路，有很多国家要求与我们建立友好关系。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915105344/2、风雨外交路开辟中国新征程.mp3',
      isMusicpause: false,

    },
    {
      text: '首探星河的“中国红”',
      desc: '孙家栋：通过第一颗卫星我们证明，就是我们能把卫星送上去，我们能做一颗卫星在天上生存。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915124956/3、首探星河的“中国红”.mp3',
      isMusicpause: false,

    },
    {
      text: '中国“两弹元勋”邓稼先',
      desc: '邓稼先：原子弹我们可以搞出来，这氢弹我们一定可以把它搞出来。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915144015/4、中国“两弹元勋”邓稼先.mp3',
      isMusicpause: false,

    },
    {
      text: '“世界杂交水稻之父”袁隆平',
      desc: '袁隆平：我有两个梦，一个是禾下乘凉梦，一个是杂交水稻覆盖全球梦。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915158571/5、“世界杂交水稻之父”袁隆平.mp3',
      isMusicpause: false,

    },
    {
      text: '我为祖国献石油',
      desc: '王进喜：我们是石油工人，我们国家汽车都没有油烧，背个煤气包，再不要等了，好好去干！',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915469787/6、我为祖国献石油.mp3',
      isMusicpause: false,

    },
  ],



  [{
      text: '中国式的四个现代化',
      desc: '邓小平：四个现代化，关键是科学技术的现代化，现代科学技术的发展，使科学与生产的关系越来越密切了。',
      isNotPause: true,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915337272/1、中国式的四个现代化.mp3',
      isMusicpause: false,

    },
    {
      text: '解放思想，实事求是',
      desc: '邓小平：今天，我主要讲一个问题就是解放思想，开动脑筋，实事求是，团结一致向前看。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1624498723045/邓小平：解放思想.mp3',
      isMusicpause: false,

    },
    {
      text: '“一国两制”',
      desc: '邓小平：“一国两制”是从中国自己实际提出来的，中国自己面临一个香港问题，一个台湾问题。而且解决这个问题只有两个方式，一个用谈判的方式，一个是用武力的方式。用和平谈判的方式解决这个问题，总要谈判的双方或者三方都能接受，香港问题是三方，用“一国两制”的方式。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1624499273884/邓小平：一国两制.mp3',
      isMusicpause: false,

    },
    {
      text: '百年奥运 中华圆梦',
      desc: '江泽民：欢迎世界各国朋友2008年光临北京，参加奥运。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915410517/4、百年奥运 中华圆梦.mp3 ',
      isMusicpause: false,

    },
    {
      text: '科学人才观',
      desc: '胡锦涛：人才是第一资源，是国家发展的战略资源。全党同志和全社会都要坚持尊重劳动、尊重知识、尊重人才、尊重创造的重大方针。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1623915430140/5、科学人才观.mp3',
      isMusicpause: false,

    },
  ],




  [{
      text: '坚持党对一切工作的领导',
      desc: '习近平：必须坚持党对一切工作的领导，不断加强和改善党的领导。',
      isNotPause: true,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1624616212246/【坚持党对一切工作的领导】.mp3',
      isMusicpause: false,

    },
    {
      text: '构建人类命运共同体',
      desc: '习近平：构建人类命运共同体是一个美好的目标，也是一个需要一代又一代人接力跑才能实现的目标。中国愿同广大成员国、国际组织和机构一道，共同推进构建人类命运共同体的伟大进程。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1624616184708/【构建人类命运共同体】.mp3',
      isMusicpause: false,

    },
    {
      text: '江山就是人民 人民就是江山',
      desc: '习近平：历史充分证明，江山就是人民，人民就是江山。人心向背关系党的生死存亡。赢得人民信任，得到人民支持，党就能克服任何困难，就能够无往而不胜。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1624616250455/【江山就是人民 人民就是江山】.mp3',
      isMusicpause: false,

    },
    {
      text: '绿水青山就是金山银山',
      desc: '习近平：既要金山银山，又要绿水青山，宁可要绿水青山，不要金山银山，因为绿水青山就是金山银山。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1624872944330/【绿水青山就是金山银山】.mp3',
      isMusicpause: false,

    },
    {
      text: '合奏“一带一路”强音',
      desc: '习近平：“一带一路”建设秉持的是共商、共建、共享原则，不是封闭的，而是开放包容的；不是中国一家的独奏，而是沿线国家的合唱。',
      isNotPause: false,
      musicSrc: 'https://ugc.hitv.com/platform_oss/1624872868027/【合奏“一带一路”强音】.mp3',
      isMusicpause: false,

    },
  ],
]
